/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIamRoleRequest
 */
export interface GetIamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof GetIamRoleRequest
     */
    id: string;
}

export function GetIamRoleRequestFromJSON(json: any): GetIamRoleRequest {
    return GetIamRoleRequestFromJSONTyped(json, false);
}

export function GetIamRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function GetIamRoleRequestToJSON(value?: GetIamRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


